export const HELP = 'helpMessages'
export const MARKET = 'offers'
export const OTHER = 'otherMessages'
export const LAST = 'lastMessages'
export const THREADS = 'threads'

export const newMarket = 'newMarket'
export const newFreight = 'newFreight'
export const newOther = 'newOther'
